<table class="table" [sextant]="'refs'" [url]="currentUrl">
	<thead>
		<tr>
			<th *ngIf="filterParams.isShowRelativeChange" title="{{ 'adminstat.users.reg_day.relative changes' | translate }}">
				{{ 'adminstat.users.reg_day.short relative changes' | translate }}
			</th>
			<th *ngIf="filterParams.isShowSourceChange" title="{{ 'adminstat.users.reg_day.source changes' | translate }}">
				{{ 'adminstat.users.reg_day.short source changes' | translate }}
			</th>
			<th (click)="refComponent.sort('ref')">
				<span class="text-nowrap">
					{{ 'adminstat.users.reg_day.group/ref' | translate }}
					<i class="fa fa-sort" aria-hidden="true"></i>
				</span>
			</th>
			<th (click)="refComponent.sort('countReg')" title="{{ 'adminstat.users.reg_day.countReg' | translate }}">
				{{ 'adminstat.users.reg_day.short countReg' | translate }}
				<i class="fa fa-sort" aria-hidden="true"></i>
			</th>
			<th (click)="refComponent.sort('usersWithSite')" title="{{ 'adminstat.users.reg_day.usersWithSite' | translate }}">
				{{ 'adminstat.users.reg_day.short usersWithSite' | translate }}
				<i class="fa fa-sort" aria-hidden="true"></i>
			</th>
			<th *ngIf="filterParams.isShowReReg" (click)="refComponent.sort('countReReg')" title="{{ 'adminstat.users.reg_day.countReReg' | translate }}" title="{{ 'adminstat.users.reg_day.countReReg' | translate }}">
				{{ 'adminstat.users.reg_day.short countReReg' | translate }}
				<i class="fa fa-sort" aria-hidden="true"></i>
			</th>
			<th (click)="refComponent.sort('createdSites')" title="{{ 'adminstat.common.sites' | translate }}">
				{{ 'adminstat.common.sites' | translate }}
				<i class="fa fa-sort" aria-hidden="true"></i>
			</th>
			<th (click)="refComponent.sort('publishedSites')" title="{{ 'adminstat.users.reg_day.publishedSites' | translate }}">
				{{ 'adminstat.users.reg_day.short publishedSites' | translate }}
				<i class="fa fa-sort" aria-hidden="true"></i>
			</th>
			<th *ngIf="filterParams.isBillingAllow" (click)="refComponent.sort('paidCount')" title="{{ 'adminstat.users.reg_day.paids' | translate }}">
				{{ 'adminstat.users.reg_day.short paids' | translate }}
				<i class="fa fa-sort" aria-hidden="true"></i>
			</th>
			<th *ngIf="filterParams.isBillingAllow" (click)="refComponent.sort('userCount')" title="{{ 'adminstat.common.Users' | translate }}">
				{{ 'adminstat.users.reg_day.short users' | translate }}
				<i class="fa fa-sort" aria-hidden="true"></i>
			</th>
			<th *ngIf="filterParams.isBillingAllow" (click)="refComponent.sort('moneyCount')" title="{{ 'adminstat.common.Money' | translate }}">
				$
				<i class="fa fa-sort" aria-hidden="true"></i>
			</th>
			<th *ngIf="filterParams.isBillingAllow" (click)="refComponent.sort('ltv')" title="LTV">
				LTV, $
				<i class="fa fa-sort" aria-hidden="true"></i>
			</th>
		</tr>
	</thead>
	
	<tbody>
		<tr
			*ngFor="let ref of refs | orderBy: {property: refComponent.column, direction: refComponent.direction}; let refIndex = index"
			[class]="ref.isGroup ? (ref.ref == 'Total' ? 'table-info ' : 'table-success') : (!ref.subGroup ? 'table-warning' : null)"
		>
			<td *ngIf="filterParams.isShowRelativeChange">
				<ng-container *ngIf="ref.ref != 'Total'">
					<span class="text-nowrap">
						<i 
							*ngIf="ref.relativeChangeValue != 0"
							[class]="ref.relativeChangeValue > 0 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'" 
							aria-hidden="true"
							[style.color]="ref.relativeChangeValue > 0 ? 'green' : 'red'"
						></i>
						{{ Math.abs(ref.relativeChangeValue).toFixed(2) }}%
					</span>
				</ng-container>
			</td>
			
			<td *ngIf="filterParams.isShowSourceChange">
				<ng-container *ngIf="ref.ref != 'Total'">
					<span class="text-nowrap">
						<i
							*ngIf="ref.sourceChangeValue != 0"
							[class]="ref.sourceChangeValue > 0 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"
							aria-hidden="true"
							[style.color]="ref.sourceChangeValue > 0 ? 'green' : 'red'"
						></i>
						{{ Math.abs(ref.sourceChangeValue).toFixed(2) }}%
					</span>
				</ng-container>
			</td>
			<td>
				<i
					*ngIf="ref.isGroup && ref.ref != 'Total' && !refComponent.itemLoader[refIndex]"
					[class]="ref.opened ? 'fa fa-minus' : 'fa fa-plus'"
					aria-hidden="true"
				></i>

				<span
					*ngIf="refs && refComponent.itemLoader[refIndex]"
					class="loader"
					style="cursor:pointer;"
				>
					<img src="/img/loader.svg" class="img-responsive">
				</span>

				<!--Группы-->
				<ng-container *ngIf="ref.ref === 'Total'; else otherGroup">
					{{ ref.ref }}
				</ng-container>
				
				<ng-template #otherGroup>
					<span
						*ngIf="ref.isGroup"
						style="cursor:pointer;"
					>
						<a
							class="js-show-ref-item-group"
							(click)="refComponent.showRefExpand(ref, refIndex)"
						>
							{{ ref.ref }}
						</a>
					</span>
						
						<!--Внутри группы-->
						<span
							*ngIf="!ref.isGroup && ref.refGroup"
						>
						<button
							style="padding-left:30px; cursor:pointer;"
							type="button"
							[sextant]="'ref-' + ref.refGroup"
							class="btn btn-link"
							(click)="refComponent.showRefDetails(ref, refIndex)"
						>
							{{ ref.ref }}
						</button>
					</span>
						
						<!--Direct, Referral, Ungrouped-->
						<span
							*ngIf="!ref.isGroup && !ref.refGroup"
							style="cursor:pointer;"
						>
						<a
							class="js-show-ref-item"
							(click)="refComponent.showRefDetails(ref, refIndex)"
						>
							{{ ref.ref }}
						</a>
					</span>
				</ng-template>
			</td>
			<td>
				<span class="text-nowrap">
					{{ ref.countReg}}
					
					<ng-container *ngIf="ref.ref != 'Total'">
						({{ helper.percentageFormat(ref.countReg / ref.totalCountReg) }})
					</ng-container>
				</span>
			</td>
			
			<td>
				<span class="ul-reg-day-ref-with-site text-nowrap">
					{{ ref.usersWithSite}}
					
					<ng-container *ngIf="ref.ref != 'Total'">
						({{ helper.percentageFormat(ref.usersWithSite / ref.countReg) }})
					</ng-container>
				</span>
			</td>
			
			<td *ngIf="filterParams.isShowReReg">
				<span class="ul-reg-day-ref-with-site text-nowrap">
					{{ ref.countReReg}}
					
					<ng-container *ngIf="ref.ref != 'Total'">
						({{ helper.percentageFormat(ref.countReReg / ref.countReg) }})
					</ng-container>
				</span>
			</td>
			
			<td>
				<span class="ul-reg-day-ref-sites text-nowrap">
					{{ ref.createdSites}}
					
					<ng-container *ngIf="ref.ref != 'Total'">
						({{ helper.percentageFormat(ref.createdSites / ref.countReg) }})
					</ng-container>
				</span>
			</td>
			<td>
				<span class="text-nowrap">
					{{ ref.publishedSites}}
					<ng-container *ngIf="ref.ref != 'Total'">
						({{ helper.percentageFormat(ref.publishedSites / ref.countReg) }})
					</ng-container>
				</span>
			</td>
			
			<td *ngIf="filterParams.isBillingAllow">
				<span class="text-nowrap">
					{{ ref.paidCount}}
					
					<ng-container *ngIf="ref.ref != 'Total'">
						({{ helper.percentageFormat(ref.paidCount / ref.countReg) }})
					</ng-container>
				</span>
			</td>
			<td *ngIf="filterParams.isBillingAllow">
				<span class="text-nowrap">
					{{ ref.userCount}}
					<ng-container *ngIf="ref.ref != 'Total'">
						({{ helper.percentageFormat(ref.userCount / ref.countReg) }})
					</ng-container>
				</span>
			</td>
			<td *ngIf="filterParams.isBillingAllow">
				<span class="text-nowrap">
					{{ ref.moneyCount / 100 }}
				</span>
			</td>
			<td *ngIf="filterParams.isBillingAllow">
				<span class="text-nowrap">
					{{ (ref.ltv / 100).toFixed(2) }}
				</span>
			</td>
		</tr>
	</tbody>
</table>
